<app-landing-toolbar></app-landing-toolbar>
<div class="wrapper">
    <mat-card>
        <mat-card-title><h1>Welcome!</h1></mat-card-title>
        <mat-card-content>
            <p>You should receive a welcome email at the email address you provided. It'll contain a link to verify your email address.</p>
            <p>As we are relatively new, Google often places this email in your "Promotions" folder!</p>
            <h1>Your account will be <span [style.color]="'red'">locked</span> until you verify your email address!</h1>
            <p><a routerLink="/login">Login</a></p>
        </mat-card-content>
    </mat-card>
</div>
